<template>
  <component
    :is="as"
    class="flex items-center w-full px-4 py-2 text-sm text-gray-700 group hover:bg-gray-100"
    role="menuitem"
    tabindex="-1"
    v-bind="attrs"
    v-on="listeners"
  >
    <slot />
  </component>
</template>

<script>
export default {
  props: {
    as: {
      type: String,
      default: 'button'
    }
  },

  computed: {
    attrs() {
      return {
        ...this.$attrs,
        name: this.name,
        value: this.value,
        checked: this.checkedValue === this.value
      }
    },

    listeners() {
      return {
        ...this.$listeners,
        input: () => {
          this.$emit('input', this.value)
        }
      }
    }
  }
}
</script>
